






















































































































































import { Component, Prop } from "vue-property-decorator";
import AbpBase from "../../lib/abpbase";
import Ticket from "../../store/entities/ticket";
import Editor from "@tinymce/tinymce-vue";
import TinymceInit from "../../lib/TinymceInit";
import MultiPicture from "../../components/multi-picture.vue";
import RegionSelect from "../../components/region-select.vue";
import { Survey } from "../../lib/tinymce-initial-value";
import appconst from "../../lib/appconst";
import Ajax from "@/lib/ajax";
TinymceInit.height = 300;

@Component({
  components: { Editor, RegionSelect, MultiPicture },
})
export default class CreateTicket extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;

  ticket: Ticket = new Ticket();
  type: boolean = false;
  showOnHome: boolean = false;
  tinymceInit = TinymceInit;
  uploadUrl: string = appconst.remoteServiceBaseUrl + "Picture/UploadPicture";
  survey = Survey;
  supplierList: Array<any> = [];
  courtList: any = [];

  get extData() {
    return {
      ticketId: this.ticket.id,
    };
  }

  save() {
    (this.$refs.ticketForm as any).validate(async (valid: boolean) => {
      if (valid) {
        await this.$store.dispatch({
          type: "ticket/create",
          data: {
            ticket: this.ticket,
            images: this.ticket.ticketImages,
          },
        });
        (this.$refs.ticketForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.ticketForm as any).resetFields();
    this.$emit("input", false);
  }
  async getSupplierList() {
    return await this.$store
      .dispatch({
        type: "supplier/GetAllSupplierListLabelAndValue",
      })
      .then((res) => {
        if (res && res.data && res.data.result) {
          this.supplierList = res.data.result;
        }
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.getCourtList();
      this.getSupplierList();
    }
  }
  async getCourtList() {
    let reponse = await Ajax.get("/api/services/app/Court/GetAllCourtNames");
    this.courtList = reponse.data.result;
  }
  async validateRegionId(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择地区"));
    }
  }
  validateStartTime(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择开始时间"));
    } else {
      callback();
    }
  }
  validateEndTime(rule, value, callback) {
    if (!value) {
      callback(new Error("请选择结束时间"));
    } else {
      callback();
    }
  }
  ticketRule = {
    name: [
      {
        required: true,
        message: "请输入名称",
        trigger: "blur",
      },
    ],
    flow: [
      {
        required: true,
        message: "请输入使用流程",
        trigger: "blur",
      },
    ],
    startTime: [
      {
        required: true,
        message: "请选择开始日期",
        validator: this.validateStartTime,
        trigger: "blur change",
      },
    ],
    endTime: [
      {
        required: true,
        message: "请选择结束日期",
        validator: this.validateEndTime,
        trigger: "blur change",
      },
    ],
    useRole: [
      {
        required: true,
        message: "请输入使用规则",
        trigger: "blur",
      },
    ],
    regionId: [
      {
        required: true,
        validator: this.validateRegionId,
        trigger: "change",
      },
    ],
    description: [
      {
        required: true,
        message: "请输入产品说明",
        trigger: "blur",
      },
    ],
  };
}
